
import { cx } from '@client/shared/lib/cx.ts';
import styles from './NewListing.module.css';

export function RadioCard({
  name,
  checked,
  onChange,
  title,
  desc,
  disabled,
}: {
  name: string;
  checked: boolean;
  onChange: () => void;
  title: string;
  desc: string;
  disabled?: boolean;
}) {
  return (
    <label className={cx(styles.radioCard, checked && styles.radioCardActive, disabled && styles.radioCardDisabled)}>
      <input
        type="radio"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className={styles.radioInput}
      />
      <span className={styles.radioDot} aria-hidden="true" />
      <span className={styles.radioBody}>
        <span className={styles.radioTitle}>{title}</span>
        <span className={styles.radioDesc}>{desc}</span>
      </span>
    </label>
  );
}
